<template>
  <div class="sup-submenu-wrap">
    <ul ref="tab" class="sup-menu-frame">
      <li class="sup-list" :class="{ 'active': $route.path === '/page/sup-how-to-register' }">
        <router-link class="sup-items-links" to="/page/sup-how-to-register">
          登録方法
        </router-link>
      </li>
      <li class="sup-list" :class="{ 'active': $route.path === '/page/sup-how-to-login' }">
        <router-link class="sup-items-links" to="/page/sup-how-to-login">
          ログイン方法
        </router-link>
      </li>
      <li class="sup-list" :class="{ 'active': $route.path === '/page/sup-verify-your-account' }">
        <router-link class="sup-items-links" to="/page/sup-verify-your-account">
          KYC認証（本人確認）方法
        </router-link>
      </li>
      <li class="sup-list" :class="{ 'active': $route.path === '/page/sup-wallet' }">
        <router-link class="sup-items-links" to="/page/sup-wallet">
          ウォレットについて
        </router-link>
      </li>
      <li class="sup-list" :class="{ 'active': $route.path === '/page/sup-payment-method' || $route.path === '/page/sup-deposit-bank' || $route.path === '/page/sup-deposit-mtpay' || $route.path === '/page/sup-deposit-vega' || $route.path === '/page/sup-deposit-jeten' || $route.path === '/page/sup-deposit-usdt' || $route.path === '/page/sup-deposit-crypto' || $route.path === '/page/sup-withdraw-bank' || $route.path === '/page/sup-withdraw-mtpay' || $route.path === '/page/sup-withdraw-vega' || $route.path === '/page/sup-withdraw-jeton' || $route.path === '/page/sup-withdraw-crypto' }">
        <router-link class="sup-items-links" to="/page/sup-payment-method">
          入出金方法
        </router-link>
      </li>
      <li class="sup-list" :class="{ 'active': $route.path === '/page/sup-account-binding' }">
        <router-link class="sup-items-links" to="/page/sup-account-binding">
          出金口座の登録方法
        </router-link>
      </li>
      <li class="sup-list" :class="{ 'active': $route.path === '/page/sup-vip-class-upgrading' }">
        <router-link class="sup-items-links" to="/page/sup-vip-class-upgrading">
          ショップについて
        </router-link>
      </li>
      <li class="sup-list" :class="{ 'active': $route.path === '/page/sup-faq' }">
        <router-link class="sup-items-links" to="/page/sup-faq">
          よくある質問
        </router-link>
      </li>
      <li
        class="sup-list"
        :class="{ 'active': $route.path === '/page/sup-self-restraint' || $route.path === '/page/sup-responsible-gaming' }"
      >
        <router-link class="sup-items-links" to="/page/sup-self-restraint">
          自己制限
        </router-link>
      </li>
    </ul>
    <div class="sup-submenu-scrollbar">
      <div id="supMenuThumb" class="sup-submenu-scrollbar-thumb" style="width: 58.5009%; left: 0px;" />
    </div>
  </div>
</template>

<script>
import themeMixin from '@/mixins/themeMixin'
export default {
  mixins: [themeMixin],
  data() {
    return {
    }
  },
  computed: {
  },
  watch: {
    $route: {
      immediate: true,
      handler(to, from) {
        this.scrollToActive()
      }
    }
  },
  methods: {
    scrollToActive() {
      this.$nextTick(() => {
        setTimeout(() => {
          const container = this.$refs['tab']
          const activeItem = container.querySelector('.active')
          if (activeItem) {
            const containerRect = container.getBoundingClientRect()
            const activeItemRect = activeItem.getBoundingClientRect()

            let scrollPosition
            if (activeItem === container.lastElementChild) {
              scrollPosition = container.scrollWidth - container.clientWidth
            } else {
              scrollPosition = activeItemRect.left - containerRect.left + container.scrollLeft - (containerRect.width / 2) + (activeItemRect.width / 2)
            }

            container.scrollLeft = scrollPosition
          }
        }, 300)
      })
    }
  }
}
</script>
